(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodTagging', sodTagging);

    function sodTagging(lodash) {

        window.sodTagging = {};

        var TO_BE_ADDED = 'TO_BE_ADDED';
        lodash.set(window.sodTagging, ['enum', TO_BE_ADDED].join('.'), TO_BE_ADDED);

        var TO_BE_REMOVED = 'TO_BE_REMOVED';
        lodash.set(window.sodTagging, ['enum', TO_BE_REMOVED].join('.'), TO_BE_REMOVED);

        var NO_CHANGE = 'NO_CHANGE';
        lodash.set(window.sodTagging, ['enum', NO_CHANGE].join('.'), NO_CHANGE);

        var __initial = '__initial';
        lodash.set(window.sodTagging, ['enum', __initial].join('.'), __initial);

        var __action = '__action';
        lodash.set(window.sodTagging, ['enum', __action].join('.'), __action);

        return {
            restrict: 'E',
            templateUrl: 'common/components/tagging/tagging',
            require: 'ngModel',
            scope: {
                options: '=',
            },
            link: function(scope, elem, attr, ctrl) {
                scope.local = {
                    add: add,
                    remove: remove,
                    existingTags: [],
                    toBeRemovedTags: [],
                };

                scope.local.tags = [];
                ctrl.$render = function() {
                    scope.local.tags = ctrl.$viewValue || [];
                    markInitialTags();

                    updateTags();
                };

                function markInitialTags() {
                    scope.local.tags = lodash.map(
                        lodash.get(scope, 'local.tags', []),
                        function (tag) {
                            var defaultObj = {};
                            lodash.set(defaultObj, window.sodTagging.enum.__initial, true);
                            lodash.set(defaultObj, window.sodTagging.enum.__action, window.sodTagging.enum.NO_CHANGE);
                            return Object.assign(defaultObj, tag);
                        }
                    );
                }

                function updateTags() {
                    var tagActionFilter = function(actions) {
                        actions = actions || [];
                        return function (oTag) {
                            return lodash.indexOf(actions, lodash.get(oTag, __action, null)) >= 0;
                        }
                    };
                    scope.local.existingTags = lodash.filter(scope.local.tags, tagActionFilter([NO_CHANGE, TO_BE_ADDED]));
                    scope.local.toBeRemovedTags = lodash.filter(scope.local.tags, tagActionFilter([TO_BE_REMOVED]));
                    ctrl.$setViewValue(scope.local.tags);
                }

                function add(item) {
                    if (!exists(item)) {
                        var defaultObj = {};
                        lodash.set(defaultObj, window.sodTagging.enum.__action, window.sodTagging.enum.TO_BE_ADDED);
                        lodash.set(defaultObj, 'value', lodash.get(item, getSchemaProp(item)));
                        scope.local.tags = scope.local.tags.concat([Object.assign(defaultObj, item)]);
                    } else {
                        var isInitial = lodash.get(item, window.sodTagging.enum.__initial, false);

                        if (isInitial) {
                            scope.local.tags = setTagAndReturnTags(item,  window.sodTagging.enum.NO_CHANGE);
                        }
                    }
                    // ctrl.$setViewValue(scope.local.tags);
                    updateTags();
                }

                function exists(item) {
                    var tmpItem = {};
                    var schemaProp = getSchemaProp(item);
                    lodash.set(tmpItem, schemaProp, lodash.get(item, schemaProp));

                    return lodash.findIndex(scope.local.tags, tmpItem) >= 0;
                }

                function remove(item) {
                    var isInitial = lodash.get(item, window.sodTagging.enum.__initial, false);

                    if (isInitial) {
                        setTagAndReturnTags(item, window.sodTagging.enum.TO_BE_REMOVED);
                    } else {
                        var tmpItem = {};
                        var schemaProp = getSchemaProp(item);
                        lodash.set(tmpItem, schemaProp, lodash.get(item, schemaProp));

                        lodash.remove(scope.local.tags, tmpItem);
                    }
                    // ctrl.$setViewValue(scope.local.tags);
                    updateTags();
                }

                function getSchemaProp(item) {
                    return lodash.get(scope, getSchemaPropPathString(item));
                }
                
                function getSchemaPropPathString(item) {
                    return [
                        'options',
                        'options',
                        'schema',
                        !lodash.has(item, 'id') ? 'label' : 'key'
                    ].join('.');
                }

                function setTagAndReturnTags(tag, action) {
                    var finalAction = (tag[window.sodTagging.enum.__action] == action) ? window.sodTagging.enum.NO_CHANGE : action;

                    lodash.set(
                        tag,
                        window.sodTagging.enum.__action,
                        // tag[window.sodTagging.enum.__action] == action ? null : action
                        finalAction
                    );



                    // return lodash.map(scope.local.tags, function (oTag) {
                    //     var found = lodash.get(oTag, 'id', null) === lodash.get(tag, 'id', undefined);
                    //     if (found) {
                    //         var defaultObj = {};
                    //         lodash.set(
                    //             defaultObj,
                    //             window.sodTagging.enum.__action,
                    //             // tag[window.sodTagging.enum.__action] == action ? null : action
                    //             action
                    //         );
                    //         return Object.assign(oTag, defaultObj);
                    //     }
                    //
                    //     return oTag;
                    // })
                }
            }
        };
    }

})();